import { DirectionProvider } from "@radix-ui/react-direction";
import { createContext, useMemo, type ReactNode } from "react";
import { IntlProvider } from "react-intl";

import {
  DEFAULT_LOCALE,
  MESSAGES,
  directionOf,
  intlLocaleOf,
  type Locale,
} from "@/shared/i18n/messages";

interface LocaleContextValue {
  locale: Locale;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = DEFAULT_LOCALE;
  const value = useMemo(() => ({ locale }), [locale]);

  return (
    <LocaleContext.Provider value={value}>
      <IntlProvider locale={intlLocaleOf(locale)} messages={MESSAGES[locale]} defaultLocale="en">
        <DirectionProvider dir={directionOf(locale)}>{children}</DirectionProvider>
      </IntlProvider>
    </LocaleContext.Provider>
  );
}
